export default __webpack_public_path__ + "static/media/certificate-of-RTA-under-regulation-74(5)-1.48120adc.pdf";